import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { toast } from 'sonner';
import { Plus, UserRound } from 'lucide-react';
import { clientsApi } from '../../services/api';
import { ContactFormDialog } from '../clients/ContactFormDialog';

const ROLES = [
  { key: 'responsable_id', label: "Responsable de l'événement", required: true, hint: 'Remise des clés, accueil, état des lieux' },
  { key: 'validateur_id', label: 'Validateur', required: false, hint: 'Reçoit le devis en copie' },
  { key: 'payeur_id', label: 'Payeur', required: false, hint: "Reçoit l'appel à participation en copie" },
];

export function EventContactsPicker({ client, value, onChange, onContactCreated }) {
  const [dialogOpen, setDialogOpen] = useState(false);
  const contacts = client?.contacts || [];

  const handleCreate = async (data) => {
    const res = await clientsApi.addContact(client.id, data);
    onContactCreated(res.data);
    if (!value.responsable_id) onChange({ ...value, responsable_id: res.data.id });
    toast.success(`Interlocuteur « ${res.data.name} » ajouté`);
  };

  return (
    <div className="rounded-lg border border-emerald-200 bg-emerald-50/50 p-3 space-y-3" data-testid="event-contacts-picker">
      <div className="flex items-center justify-between gap-2">
        <span className="text-sm font-semibold text-emerald-800 flex items-center gap-1.5">
          <UserRound className="h-4 w-4" /> Interlocuteurs de l'événement
        </span>
        <Button type="button" variant="ghost" size="sm" onClick={() => setDialogOpen(true)} className="text-[#2563EB] hover:text-[#1e3a8a] h-auto py-1 px-2" data-testid="new-event-contact-button">
          <Plus className="h-4 w-4 mr-1" /> Nouvel interlocuteur
        </Button>
      </div>
      {ROLES.map((role) => (
        <div key={role.key} className="space-y-1">
          <Label className="text-xs">
            {role.label} {role.required ? '*' : <span className="text-slate-400">(facultatif)</span>}
          </Label>
          <Select
            value={value[role.key] || 'none'}
            onValueChange={(v) => onChange({ ...value, [role.key]: v === 'none' ? '' : v })}
          >
            <SelectTrigger className="h-9 bg-white" data-testid={`event-contact-${role.key.replace('_id', '')}-select`}>
              <SelectValue placeholder="Sélectionner..." />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="none">{role.required ? 'Sélectionner un interlocuteur...' : 'Non désigné'}</SelectItem>
              {contacts.map((c) => (
                <SelectItem key={c.id} value={c.id}>
                  {c.name}{c.function ? ` — ${c.function}` : ''}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <p className="text-[11px] text-slate-500">{role.hint}</p>
        </div>
      ))}
      <ContactFormDialog open={dialogOpen} onOpenChange={setDialogOpen} onSave={handleCreate} />
    </div>
  );
}
